import Vue from 'vue'
import confirm from './confirm'
import prompt from './prompt'
import modal from './modal'
import reportSpam from './reportSpam'
import ensure from './ensure'
import message from './message'
import addfolder from './addfolder'
import checkphone from './checkphone'
import addAddr from './addAddr'
import checksms from './checksms'

let instance
// const ConfirmConstructor = Vue.extend(confirm)
// const PromptConstructor = Vue.extend(prompt)
// const ReportSpamConstructor = Vue.extend(reportSpam)
// const ensureConstructor = Vue.extend(ensure)
// const messageConstructor = Vue.extend(message)
// const addfolderConstructor = Vue.extend(addfolder)
// const checkphoneConstructor = Vue.extend(checkphone)
// const addAddrConstructor = Vue.extend(addAddr)
// const checksmsConstructor = Vue.extend(checksms)

let initInstance = (constructor, options) => {
    instance = new constructor({
        el: document.createElement('div'),
        data: options
    })
    document.body.appendChild(instance.$el)
}

let register = (component) => {
    return (options = {}) => {
        initInstance(Vue.extend(component), options)  
    }
}
// let Confirm = (options = {}) => {
//     initInstance(ConfirmConstructor, options)
// }
// let Prompt = (options = {}) => {
//     initInstance(PromptConstructor, options)
// }

// let EnSure = (options = {}) => {
//     initInstance(ensureConstructor, options)
// }

// let ReportSpam = (options = {}) => {
//     initInstance(ReportSpamConstructor, options)
// }

// let Message = (options = {}) => {
//     initInstance(messageConstructor, options)
// }

// let Addfolder = (options = {}) => {
//     initInstance(addfolderConstructor, options)
// }

// let Checkphone = (options = {}) => {
//     initInstance(checkphoneConstructor, options)
// }

// let AddAddr = (options = {}) => {
//     initInstance(addAddrConstructor, options)
// }

// let Checksms = (options = {}) => {
//     initInstance(checksmsConstructor, options)    
// }


const install = function (Vue) {
    Vue.component(modal.name, modal)

    Vue.prototype.$checksms = register(checksms)
    Vue.prototype.$confirm = register(confirm)
    Vue.prototype.$prompt = register(prompt)
    Vue.prototype.$ensure = register(ensure)
    Vue.prototype.$reportSpam = register(reportSpam)
    Vue.prototype.$message = register(message)
    Vue.prototype.$addfolder = register(addfolder)
    Vue.prototype.$checkphone = register(checkphone)
    Vue.prototype.$addAddr = register(addAddr)
    
}
export default install



// WEBPACK FOOTER //
// ./src/components/modal/index.js